<template>
    <job-sheets-entries-store
        ref="job_sheets_entries_store"
        :params="{
            job_sheet: jobSheet.uuid
        }"
        v-slot="{
            sid,
            is_loading: is_saving,
            error,
            store
        }"
        @success="() => {
            reset();
            $emit('success');
        }"
    >
        <base-form @submit="store(form)">
            <div class="flex px-4 py-3 border-b bg-grey-lightest sm:px-6">
                <h6 class="flex-grow text-lg">Leave a comment</h6>

                <the-notification
                    class="flex-none"
                    :job-sheet="jobSheet"
                />
            </div>

            <div class="px-4 pt-6 border-b sm:px-6">
                <form-item
                    :sid="sid"
                    :is-required="true"
                    name="text"
                >
                    <template slot="label">Comment</template>

                    <div class="relative">
                        <input-textarea
                            v-model="form.text"
                            :sid="sid"
                            :disabled="is_saving"
                            name="text"
                            class="h-32"
                        />
                    </div>
                </form-item>

                <form-item
                    :sid="sid"
                    name="uploads"
                >
                    <template slot="label">Files</template>

                    <input-uploads
                        v-model="form.uploads"
                        name="uploads"
                        ref="uploads"
                        :sid="sid"
                        :max-files="20"
                        :disabled="is_saving"
                    />
                </form-item>
            </div>

            <div class="px-4 py-3 text-right rounded-b bg-grey-bg sm:px-6">
                <base-button
                    :is-loading="is_saving"
                    class="w-full btn-blue md:w-auto"
                >
                    Submit Comment
                </base-button>
            </div>

            <error-modal
                v-if="error && $error.is(error, { exclude: [422] })"
                :error="error"
            />
        </base-form>
    </job-sheets-entries-store>
</template>

<script>
    import JobSheetsEntriesStore from '../../../components/job-sheets-entries-store'
    import TheNotification from './the-comment-form/the-notification'

    export default {
        components: {
            JobSheetsEntriesStore,
            TheNotification
        },
        props: {
            jobSheet: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                form: {
                    text: '',
                    uploads: []
                }
            }
        },
        methods: {
            reset () {
                this.form.text = ''
                this.form.uploads = []

                this.$refs.uploads.reset()
                this.$refs.job_sheets_entries_store.forget()
            }
        }
    }
</script>
